module.exports = __webpack_public_path__ + "media/Legion of Terror.bcc13d6f.mp3";